(function ($) {

    if ($('.single-article').length) {

        var ua = navigator.userAgent.toLowerCase();
        var isSafari = false;
        if (ua.indexOf('safari') != -1) {
            if (ua.indexOf('chrome') > -1) {
                isSafari = false;
            } else {
                isSafari = true;
            }
        }

        if (isSafari) {
            $('.article-content').addClass('is-safari');
        }

        //SCROLL MAGIC

        var deviceHeight = $(window).innerHeight();

        // console.log(deviceHeight);


        function myFunction(x) {
            if (x.matches) {
                deviceHeight = window.screen.availHeight;
            } else {
                deviceHeight = $(window).innerHeight();
            }
        }

        var x = window.matchMedia("(max-width: 420px)");
        myFunction(x);

        $(window).on("resize", function () {
            setTimeout(function () {

                myFunction(x);
            }, 300);
        });

        $('.full-screen-image-block').each(function (index, element) {
            $(element).data('idx', index);

            var bgImages = document.querySelectorAll('.bg-images');

            var fullScreenRepeater = $(element).find('.full-screen-repeater-block');

            fullScreenRepeater.each(function (idx, el) {

                var scrollerController;
                var scene1;

                createScrollMagic1();

                function createScrollMagic1() {
                    scrollerController = new ScrollMagic.Controller();

                    scene1 = new ScrollMagic.Scene({
                        triggerElement: el,
                        reverse: true,
                        triggerHook: 0,
                        duration: $(el).outerHeight()
                    })
                        .addTo(scrollerController)
                        // .addIndicators() // add indicators (requires plugin)
                        .on("enter", function (e) {
                            var bgImageId = $(el).data('bg');

                            if (bgImageId) {
                                $(element).find('.bg-image').removeClass('active');
                                setTimeout(function () {
                                    $(element).find('.bg-image').removeClass('previous')
                                }, 750);

                                $(element).find('.bg-image' + bgImageId).addClass('active');
                                setTimeout(function () {
                                    $(element).find('.bg-image' + bgImageId).addClass('previous')
                                }, 750);
                            }
                        })
                }

                function destroyController() {
                    scrollerController.destroy(true);
                    scene1.destroy(true);
                }

                $(window).on("resize", function () {

                    setTimeout(function () {
                        destroyController();
                        createScrollMagic1();
                    }, 300);
                });
            });

            var bgController;
            var scene2;

            createScrollMagic2();

            function createScrollMagic2() {

                bgController = new ScrollMagic.Controller();

                var repeaterBlockWrapper = $(element).find('.repeater-block-wrapper');

                var triggerEl = $(element)

                scene2 = new ScrollMagic.Scene({
                    triggerElement: triggerEl[0],
                    reverse: true,
                    triggerHook: 0,
                    duration: repeaterBlockWrapper.outerHeight() - deviceHeight
                })
                    .setPin(bgImages[index])
                    .addTo(bgController)
                // .addIndicators({indent: 200}) // add indicators (requires plugin)
            }

            function destroyBgController() {
                bgController.destroy(true);
                scene2.destroy(true);
            }

            $(window).on("resize", function () {
                setTimeout(function () {
                    destroyBgController();
                    createScrollMagic2();
                }, 300);
            });
        });

        // Sticky divider blocks

        var dividers = $('.section-divider');
        var stickyDividers = $('.sticky-divider');
        var referencesSection = $('.article-content .chw-widget-area');

        $(window).on('scroll', function() {
            dividers.each(function() {
                var rect = $(this)[0].getBoundingClientRect();
                var dividerTop = rect.top;
                var dividerBottom = rect.bottom;

                if (dividerBottom <= 0) {
                    if ($(this).next('.sticky-divider').hasClass('sticky-hidden')) {
                        $(this).next('.sticky-divider').removeClass('sticky-hidden');
                    }
                }
                else if ((dividerTop + 70) <= $(window).height()) {
                    stickyDividers.filter(':not(.sticky-hidden)').addClass('sticky-hidden');
                }
            });

            if (referencesSection[0].getBoundingClientRect().top <= 100) {
                stickyDividers.filter(':not(.sticky-hidden)').addClass('sticky-hidden');
            }
        })

        $('.footnote_reference_container_label').on('click', function() {
            $(this).toggleClass('expand');
        })
    }

})(jQuery);